var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.003,
    height: 22,
    viewBox: "0 0 22.003 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout",
    transform: "translate(-24 -1031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31034",
    "data-name": "Path 31034",
    d: "M2273.244,2349.953a.909.909,0,0,1-.977.609q-6.062-.015-12.123-.006h-.309c.086.1.136.163.192.221q1.214,1.28,2.429,2.557a.877.877,0,0,1,.289.641.754.754,0,0,1-.413.7.681.681,0,0,1-.782-.078,1.608,1.608,0,0,1-.166-.158l-3.895-4.089a.829.829,0,0,1,0-1.179q1.947-2.045,3.893-4.09a.772.772,0,0,1,.781-.3.8.8,0,0,1,.424,1.248,3.244,3.244,0,0,1-.277.308l-2.5,2.628h.329q6.073,0,12.145-.006a.9.9,0,0,1,.954.608Z",
    transform: "translate(-2227.241 -1307.766)",
    fill: "#ffb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31035",
    "data-name": "Path 31035",
    d: "M2119.254,2233.478a11,11,0,0,1-4.515-21.01,10.95,10.95,0,0,1,14.714,5.885.754.754,0,1,1-1.386.568,9.251,9.251,0,0,0-6.421-5.636,9.479,9.479,0,1,0,6.385,12.8c.127-.305.29-.562.644-.615a.735.735,0,0,1,.8,1.042,13.841,13.841,0,0,1-.933,1.832,10.723,10.723,0,0,1-7.5,4.956C2120.449,2233.4,2119.848,2233.421,2119.254,2233.478Z",
    transform: "translate(-2084.293 -1180.478)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.c901e7b1432038795e9e89001760d096.svg";
export { ForwardRef as ReactComponent };